import React, {useState} from 'react'
import {Container, Form, Button, Nav, FloatingLabel, Col} from 'react-bootstrap'
import {Link} from 'react-router-dom'



export default function Signup(props) {

    const [newUser, setNewUser] = useState({})
    
    

    const changeHandler = (e) => {
        const user = {...newUser};
        user[e.target.name] = e.target.value;
        // console.log(user)
        setNewUser(user)
        
    }

    const registerHandler = () => {
        props.register(newUser)
    }

   

  return (
    <div>
       
        <img src="../zen-brush-symbol.png" alt="enzo" className="zen-logo"/>
        <h1>Zen Journal</h1>
        <p>A clean and simple app to time and track meditations</p>
        <h2>Sign Up</h2>

    <Container>
    <Col sm={5} className="center-form">
        <FloatingLabel controlId="floatingInput" label="First Name" className="mb-3">
            <Form.Control type="text" name="firstName" placeholder="First Name" onChange={changeHandler} required></Form.Control>
        </FloatingLabel>
        <FloatingLabel controlId="floatingInput2" label="Last Name" className="mb-3">
            <Form.Control type="text" name="lastName" placeholder="Last Name" onChange={changeHandler} required></Form.Control>
        </FloatingLabel>
        <FloatingLabel controlId="floatingInput3" label="Email Address" className="mb-3">
            <Form.Control type="email" name="emailAddress" placeholder="name@example.com" onChange={changeHandler} required></Form.Control>
        </FloatingLabel>
        <FloatingLabel controlId="floatingPassword" label="Password">
            <Form.Control type="password" name="password" minlength="6" placeholder="Password" onChange={changeHandler} required></Form.Control>
        </FloatingLabel>

        <Button variant="dark" onClick={registerHandler}>Register</Button>
        <Nav>
            <p>Already registered?</p>&nbsp;
            <Link to="/signin">Sign In</Link>
        </Nav>
        </Col>
    </Container>

    </div>
  )
}